module.exports = __webpack_public_path__ + "img/IMG_9181-224_L_WoodMatted_MockedUp.8065025d.jpg";